/**
 * Copyright © 2026 Adnuntius AS.
 */
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {ButtonsModule} from 'ngx-bootstrap/buttons';

import {APP_SHARED} from '../app-shared';
import {ADMIN_RESOURCE_PAGES} from '../controller/admin-resource-pages';
import {ObjectStatesComponent} from './object-states.component';
import {ViewObjectStatesComponent} from './view-object-states.component';

export const ADMIN_LIST_IMPORTS = [
  ...APP_SHARED,
  ...ADMIN_RESOURCE_PAGES,
  FormsModule,
  ObjectStatesComponent,
  ViewObjectStatesComponent,
  TranslateModule,
  ButtonsModule
];
